export const getShaderName = (shaderName, racerName) => {
  return `${racerName.replace(/\s/g, "_")}_${shaderName}`;
};
